import Link from "next/link";
import { CSSProperties, ReactNode } from "react";

import { ButtonContentType } from "@/states/page-editor/template-parts/common";
import { getCorrectUrl } from "@/utils/common";
import { contentToHtml } from "@/utils/draft";

interface Props {
  buttonContent: ButtonContentType;
  formPath: string | undefined;
  onClick?: () => void;
  disabled?: boolean;
}

export default function CommonButtonContent({
  buttonContent,
  formPath,
  onClick,
  disabled,
}: Props) {
  const buttonHref = (): string => {
    if (buttonContent.link?.url) {
      return getCorrectUrl(buttonContent.link?.url);
    }
    if (formPath) {
      return formPath;
    }
    return "";
  };

  const isNewTab = !!(
    buttonContent.link?.isNewTab || buttonContent.service?.isNewTab
  );

  function ButtonRenderer({
    children,
    styles,
    disabled,
  }: {
    children: ReactNode;
    styles?: CSSProperties;
    disabled?: boolean;
  }) {
    const baseClassNames =
      "cursor-pointer transition disabled:pointer-events-none disabled:cursor-default";
    const linkRef = buttonHref();

    if (disabled) {
      return (
        <div className={baseClassNames + " opacity-50"} style={styles}>
          {children}
        </div>
      );
    }

    return linkRef ? (
      <Link
        href={linkRef}
        className={baseClassNames}
        style={styles}
        target={isNewTab ? "_blank" : undefined}>

        {children}

      </Link>
    ) : (
      <button className={baseClassNames} onClick={onClick} disabled={disabled}>
        {children}
      </button>
    );
  }

  return (
    !!buttonContent?.content && (
      <ButtonRenderer styles={buttonContent.cssProperties} disabled={disabled}>
        <div
          dangerouslySetInnerHTML={{
            __html: contentToHtml(buttonContent.content),
          }}
          className="py-2 px-4 max-w-full min-h-[2rem] font-bold text-white rounded border-2 md:px-10"
          style={{
            minWidth: "8rem",
            borderColor: buttonContent.cssProperties.borderColor,
            backgroundColor: buttonContent.cssProperties.backgroundColor,
            ...buttonContent.textBaseStyle,
          }}
        ></div>
      </ButtonRenderer>
    )
  );
}
